import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row q-pb-md text-center text-caption text-fun-label-and-icon justify-around" }
const _hoisted_2 = { class: "q-mb-sm" }
const _hoisted_3 = { class: "q-mb-sm" }

import SfxIssueBase from "src/components/issue/SfxIssueBase.vue"
import { computed, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits

const checkboxSize = "112px"


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxIssueAdditionalRequirements',
  props: {
  isolationChecked: {
    type: Boolean,
    default: false,
  },

  shutdownChecked: {
    type: Boolean,
    default: false,
  },

  required: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:isolationChecked", "update:shutdownChecked", "hide"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

__expose({ forceHide, forceShow })

//endregion

//region Variables

const { t } = useI18n()

const issueBase = ref<typeof SfxIssueBase | undefined>()
const title = t("sfxIssues.title_requirements")

const isolationCheckedModel = computed({
  get() {
    return props.isolationChecked
  },

  set(value) {
    return emit("update:isolationChecked", value)
  },
})

const shutdownCheckedModel = computed({
  get() {
    return props.shutdownChecked
  },

  set(value) {
    return emit("update:shutdownChecked", value)
  },
})

const promptDiscard = computed(() => Boolean(props.isolationChecked || props.shutdownChecked))

//endregion

//region Functions

function hideMenu() {
  shutdownCheckedModel.value = false
  isolationCheckedModel.value = false
  emit("hide")
}

function forceHide() {
  hideMenu()
  issueBase.value?.forceHide()
}

function forceShow() {
  issueBase.value?.forceShow()
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_checkbox = _resolveComponent("q-checkbox")!

  return (_openBlock(), _createBlock(SfxIssueBase, {
    ref_key: "issueBase",
    ref: issueBase,
    title: _unref(title),
    required: props.required,
    "prompt-discard": promptDiscard.value,
    "info-notification": "",
    onHide: hideMenu
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("sfxIssues.label_isolation")), 1),
          _createVNode(_component_q_checkbox, {
            modelValue: isolationCheckedModel.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isolationCheckedModel).value = $event)),
            "keep-color": "",
            dense: "",
            color: "navy-base",
            size: checkboxSize,
            class: "sfx-checkbox"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("sfxIssues.label_shutdown")), 1),
          _createVNode(_component_q_checkbox, {
            modelValue: shutdownCheckedModel.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((shutdownCheckedModel).value = $event)),
            "keep-color": "",
            dense: "",
            color: "navy-base",
            size: checkboxSize,
            class: "sfx-checkbox"
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "required", "prompt-discard"]))
}
}

})